
// Wrap text of WPForms button in span to prevent text being displayed behind button shadow overlay
jQuery(document).ready(function() {
  jQuery('.wpforms-form button[type="submit"]').each(function() {
    var button = jQuery(this);
    // Check if it already has a span to avoid double-wrapping
    if (button.children('span').length === 0) {
      var text = button.text();
      button.empty().append(jQuery('<span>').text(text));
    }
  });
});
